import { EmbedAssistantPage } from "@/features/ai-hub/assistant/components/chat-embed";
import { createFileRoute } from "@tanstack/react-router";




export const Route = createFileRoute('/embed/assistant/$assistantId')({
  component: EmbedAssistantPage,
})